module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/NF-4db2f3f53f60861126bdfecc437f929a.png";